import React from 'react';

import { FaIcon } from '@shipstation/svgs';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from 'ui-components/components/button';

import testid from '../../services/testid-service';
import FloatLabel from '../float-label';
import RequiredIndicator from '../required-indicator';

import style from './float-input.less';

class FloatInputComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      slideLabelUp: !!props.value || props.value === 0,
      isPasswordVisible: false,
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.input.focus();
    }
  }

  onClick = () => {
    this.setState({ slideLabelUp: true });
    this.input.focus();
  };

  onFocus = () => {
    if (!this.state.slideLabelUp) {
      this.setState({
        slideLabelUp: true,
      });
    }
  };

  onBlur = (e) => {
    if (this.state.slideLabelUp !== !!e.target.value) {
      this.setState({
        slideLabelUp: !!e.target.value || e.target.value === 0,
      });
    }
  };

  onChange = (e) => {
    const value = e.target.value;
    if (document.activeElement !== this.input && this.state.slideLabelUp !== !!value) {
      this.setState({
        slideLabelUp: !!value || value === 0,
      });
    }

    this.props.onChange(value);
  };

  togglePasswordVisibility = (e) => {
    e.stopPropagation();
    this.setState((prev) => ({
      ...prev,
      isPasswordVisible: !prev.isPasswordVisible,
    }));
  };

  render() {
    const {
      type = 'text',
      value = '',
      label,
      hasError = false,
      required = false,
      disabled = false,
      inlineErrorMessage,
      isPassword = false,
      isPrivate = false,
      'data-testid': dataTestId = null,
      maxLength,
    } = this.props;
    const { isPasswordVisible, slideLabelUp } = this.state;
    // setting this attribute will tell logrocket not to capture the data
    const dataPrivate = { 'data-private': isPrivate ? '' : null };
    const className = classNames(
      style['float-input'],
      { [style.error]: hasError },
      { [style.disabled]: disabled },
      { [style.password]: isPassword },
      // setting this class hides the input from medial
      { 'median-exclude-selector': isPrivate },
      this.props.className || '',
    );

    const passwordVisibilityIcon = isPasswordVisible ? 'faEyeSlash' : 'faEye';
    const dynamicType = isPasswordVisible ? 'text' : 'password';

    return (
      <div className={className} onClick={this.onClick}>
        <FloatLabel
          className={style['float-label-container-background']}
          hasError={hasError}
          labelText={inlineErrorMessage || label}
          slideUp={slideLabelUp || disabled}
        />
        {required && <RequiredIndicator className={style['required-indicator']} />}
        <input
          ref={(el) => (this.input = el)}
          disabled={disabled}
          maxLength={maxLength}
          onBlur={this.onBlur}
          onChange={this.onChange}
          onFocus={this.onFocus}
          type={isPassword ? dynamicType : type}
          value={value}
          {...dataPrivate}
          {...testid(dataTestId)}
        />
        {isPassword && (
          <Button
            ariaLabel='Show / Hide password'
            className={style['visibility-icon']}
            onClick={this.togglePasswordVisibility}
            tabIndex={-1}
            theme='white'
          >
            <FaIcon name={passwordVisibilityIcon} />
          </Button>
        )}
      </div>
    );
  }
}

FloatInputComponent.propTypes = {
  type: PropTypes.string,
  label: PropTypes.node.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  hasError: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  inlineErrorMessage: PropTypes.string,
  isPassword: PropTypes.bool,
  isPrivate: PropTypes.bool,
  'data-testid': PropTypes.string,
};

export default FloatInputComponent;
